// Facade for the active vase shader material — DOES NOT IMPORT three.js so it
// can be loaded by panels in the main bundle without dragging the WebGL stack.
// The Viewer (loaded lazily) calls registerVaseHandlers + sets activeVase.material
// when it builds a vase. Panels read activeVase.material as a truthy check and
// invoke updateActiveVase* to push uniform updates without a mesh rebuild.

export interface TextureGridLike { w: number; h: number; data: Float32Array }

export interface VaseUniformOpts {
  intensity?: number;
  repeatU?: number;
  repeatV?: number;
  zMin?: number;
  zMax?: number;
  falloffBottom?: number;
  falloffTop?: number;
  falloffCurve?: number;
  surfaceSmoothing?: number;
}

/** Opaque reference — Viewer assigns the actual ShaderMaterial. Panels treat it
 * as `unknown` and only test truthiness. */
export const activeVase: { material: unknown | null } = { material: null };

const handlers: {
  uniforms: ((opts: VaseUniformOpts) => boolean) | null;
  texture: ((grid: TextureGridLike) => boolean) | null;
} = { uniforms: null, texture: null };

export function registerVaseHandlers(h: {
  uniforms: (opts: VaseUniformOpts) => boolean;
  texture: (grid: TextureGridLike) => boolean;
}): void {
  handlers.uniforms = h.uniforms;
  handlers.texture = h.texture;
}

export function clearVaseHandlers(): void {
  handlers.uniforms = null;
  handlers.texture = null;
  activeVase.material = null;
}

export function updateActiveVaseUniforms(opts: VaseUniformOpts): boolean {
  return handlers.uniforms?.(opts) ?? false;
}

export function updateActiveVaseTexture(grid: TextureGridLike): boolean {
  return handlers.texture?.(grid) ?? false;
}
